import { render, staticRenderFns } from "./ReplyComment.vue?vue&type=template&id=16553df8&scoped=true"
import script from "./ReplyComment.vue?vue&type=script&lang=js"
export * from "./ReplyComment.vue?vue&type=script&lang=js"
import style0 from "./ReplyComment.vue?vue&type=style&index=0&id=16553df8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16553df8",
  null
  
)

export default component.exports